import { ChangeState, Review } from '@monorepo/interfaces';
import { FleetBrowseFilters } from '../../shared/interfaces/fleet-management/fleet-browse-filter.interface';
import { TableSortState } from '../../shared/interfaces/table-sort-state';

export class LoadContracts {
    static readonly type = '[Fleet Management] Load contracts';

    constructor(
        public payload: {
            periodId: string;
            changeState: ChangeState;
            page?: number;
            pageSize?: number;
        }
    ) {}
}

export class LoadSelectedPeriod {
    static readonly type = '[Fleet Management] Load period';

    constructor(
        public payload: {
            period: string;
            accountingUnitId: string;
            page?: number;
            pageSize?: number;
        }
    ) {}
}

export class SubmitReview {
    static readonly type = '[Fleet Management] Submit review';

    constructor(
        public payload: {
            periodId: string;
            review: Review;
        }
    ) {}
}

export class LoadBrowseContracts {
    static readonly type = '[Fleet Management] Load contracts for browse';

    constructor(
        public payload: {
            accountingUnitId: string;
            isSubmitted: boolean;
            startMonth: string;
            endMonth: string;
            filter?: FleetBrowseFilters;
            page?: number;
            pageSize?: number;
            sort?: TableSortState;
        }
    ) {}
}

export class DownloadBrowseContracts {
    static readonly type = '[Fleet Management] Download contracts for browse';

    constructor(
        public payload: {
            accountingUnitId: string;
            isSubmitted: boolean;
            startMonth: string;
            endMonth: string;
            filter?: FleetBrowseFilters;
            sort?: TableSortState;
        }
    ) {}
}

export class ClearDownloadLink {
    static readonly type = '[Fleet Management] Clear Download Link';
}

export class LoadWarningContracts {
    static readonly type = '[Fleet Management] Load warning contracts';

    constructor(
        public payload: {
            periodId: string;
            page?: number;
            pageSize?: number;
        }
    ) {}
}

export class DeleteAllPeriods {
    static readonly type = '[Fleet Management] Delete all periods for accounting unit';

    constructor(
        public payload: {
            accountingUnitId: string;
        }
    ) {}
}

export class MovePeriodBackward {
    static readonly type = '[Fleet Management] Move period backward';

    constructor(
        public payload: {
            periodId: string;
            newMonth: Date;
        }
    ) {}
}
